module.exports = __webpack_public_path__ + "files/5c54eda78ae4968657ee616b1e971816.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-3.png
// module id = 1485
// module chunks = 60